import fetch from '../request/fetch';
export default {
    login(
        data
    ) {
        return fetch.post('/core/login', data).then(res => {
            const {
                data
            } = res;
            return data
        })
    },
    goOut() {
        return fetch.put(`/core/logout`).then(res => {
            const {
                data
            } = res;
            return data
        })
    },
    submitAudit(data) {
        return fetch.put('/core/data', data).then(res => {
            return res
        })
    },
    getCommondList(data) {
        return fetch.get('/core/data', {
            params: data
        }).then(res => {
            const {
                data
            } = res;
            return data
        })
    },
    // 楼盘列表
    buildList(data) {
        return fetch.get('/core/buildings', {
            params: data
        }).then(res => {
            return res
        })
    },
    // 渠道列表
    channelsList() {
        return fetch.get('/core/channels', {
            params: {}
        }).then(res => {
            return res
        })
    },
    delItem(data) {
        return fetch.delete('/core/data', {
            data: data
        }).then(res => {
            return res
        })
    },
    submitAgain(
        data
    ) {
        return fetch.post('/core/renew_data', data).then(res => {
            return res
        })
    },
    changeItem(data) {
        return fetch.put('/core/data', data).then(res => {
            return res
        })
    },
    getUserList(data) {
        return fetch.get('/core/user', {
            params: data
        }).then(res => {
            return res
        })
    },
    editUser(data) {
        return fetch.put('/core/user',
            data
        ).then(res => {
            return res
        })
    },
    editPsw(data) {
        return fetch.put('/core/password',
            data
        ).then(res => {
            return res
        })
    },
    getCitys(data) {
        return fetch.get('/core/locations',
            data
        ).then(res => {
            return res
        })
    },
    exportFile(data) {
        return fetch.get('/core/export_data', {
            params: data
        }).then(res => {
            console.log(res);
            const download = "https://www.hblcyx.cn/download/" + res.data.filename;
            window.open(download);
            // const blob = new Blob([res], {
            //     type: 'application/vnd.ms-excel'
            // });
            // const fileName = name + '.xls';
            // const linkNode = document.createElement('a');
            // linkNode.download = fileName; //a标签的download属性规定下载文件的名称
            // linkNode.style.display = 'none';
            // linkNode.href = URL.createObjectURL(blob); //生成一个Blob URL
            // document.body.appendChild(linkNode);
            // linkNode.click(); //模拟在按钮上的一次鼠标单击
            // URL.revokeObjectURL(linkNode.href); // 释放URL 对象
            // document.body.removeChild(linkNode);
        })
    },
    importRequest(data) {
        return fetch.post('/core/import_data', data).then(res => {
            const {
                data
            } = res;
            return data
        })
    }
}